import { useState } from 'react';
import { Button, makeStyles, tokens, Text } from '@fluentui/react-components';
import { useSelectionStore } from '@/stores/selectionStore';
import { useFileMail } from '@/features/file-mail/useFileMail';
import { useUiStore } from '@/stores/uiStore';
import { useRecentProjectsStore } from '@/stores/recentProjectsStore';
import {
  DestinationPicker,
  EMPTY_DESTINATION,
  isDestinationReady,
  type Destination,
} from '@/features/destination/DestinationPicker';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalM,
    padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalXS}`,
  },
  actions: { display: 'flex', justifyContent: 'flex-end', gap: tokens.spacingHorizontalS },
});

export function QuickFile() {
  const styles = useStyles();
  const selection = useSelectionStore((s) => s.items);
  const setView = useUiStore((s) => s.setView);
  const touchRecent = useRecentProjectsStore((s) => s.touch);
  const [dest, setDest] = useState<Destination>(EMPTY_DESTINATION);
  const fileMail = useFileMail();

  const ready = isDestinationReady(dest);

  const onConfirm = () => {
    if (!ready || !dest.containerId) return;
    touchRecent(dest.containerId);
    fileMail.mutate(
      { targetFolderId: dest.folderId, targetContainerId: dest.containerId, items: selection },
      { onSettled: () => setView('tree') },
    );
  };

  return (
    <div className={styles.root}>
      <Text size={400} weight="semibold">
        Ranger {selection.length === 0 ? 'le mail courant' : `${selection.length} mail(s)`}
      </Text>

      <DestinationPicker value={dest} onChange={setDest} />

      <div className={styles.actions}>
        <Button appearance="secondary" onClick={() => setView('tree')}>
          Annuler
        </Button>
        <Button
          appearance="primary"
          onClick={onConfirm}
          disabled={!ready || fileMail.isPending}
        >
          {fileMail.isPending ? 'Rangement…' : 'Ranger'}
        </Button>
      </div>
    </div>
  );
}
